import axios from "axios";
const BASIC_API_URL = "/api";

/*interface UserResponse {
  status: number;
  message?: string;
  user?: User;
}*/

/*export const getGroupe = async () => {
  try {
    const response = await axios.get(`${BASIC_API_URL}/company`);
    return response;
  } catch (error) {
    console.log(process.env.BASIC_API_URL);
    throw new Error(`${error.response.data.error}`);
  }
};*/

export const newGroupe = async (companyData) => {
  try {
    const response = await axios.post(
      `${BASIC_API_URL}/company/newCompany`,
      companyData
    );
    return response.data;
  } catch (error) {
    console.error("Erreur lors de l'ajout de l'entreprise :", error);
    throw new Error("Erreur lors de l'ajout de l'entreprise");
  }
};

export const getGroupeByCompID = async (compID) => {
  try {
    const response = await axios.get(`${BASIC_API_URL}/group/byComp/${compID}`);
    return response;
  } catch (error) {
    console.log(compID);
    throw new Error(`${error.response.data.error}`);
  }
};
